<mat-dialog-content class="loan-card-dialog-container">
    <div class="loan-card-controll-area">
        <div class="prev-next-bookmark-button-area">
            <div class="loan-card-bookmark-area" mat-stroked-button (click)="updateCardBookmark()">
                <i class="fa-bookmark" [ngClass]="{ fas: bookmarked, far: !bookmarked }"></i>
            </div>
            <mat-button-toggle-group
                class="prev-next-button-group"
                name="fontStyle"
                aria-label="Font Style"
                *ngIf="
                    listOfLoansTracker?.loanNumbers?.length > 1 &&
                    !isOriginatedFromLoanProfitability
                "
                [hideSingleSelectionIndicator]="true"
            >
                <mat-button-toggle
                    [disabled]="disablePrev"
                    (click)="navigateToPrevLoan()"
                    class="prev-next-button"
                    >Prev</mat-button-toggle
                >
                <mat-button-toggle
                    [disabled]="disableNext"
                    (click)="navigateToNextLoan()"
                    class="prev-next-button"
                    >Next</mat-button-toggle
                >
            </mat-button-toggle-group>
            <div
                (click)="openLoanProfitabilityDialog()"
                class="loan-profitability-navigation"
                mat-dialog-close
                *ngIf="isOriginatedFromLoanProfitability"
            >
                Back to Loan Profitability
            </div>
        </div>
        <div class="loan-card-close-cross-container">
            <i class="fas fa-times" mat-dialog-close></i>
        </div>
    </div>

    <!-- Top card -->
    <div class="al-grid grid-1">
        <div class="g-card">
            <app-loan-card-details
                [loanNumber]="loanNumber"
                (dataLoaded)="updateLOS($event)"
            ></app-loan-card-details>
        </div>
    </div>

    <!-- Middle 4 cards -->
    <div class="al-grid grid-2">
        <!-- Milestones -->
        <div class="g-card">
            <app-loan-card-milestones [loanNumber]="loanNumber"></app-loan-card-milestones>
        </div>

        <!-- Risk -->
        <div class="g-card">
            <app-loan-card-risk [loanNumber]="loanNumber"></app-loan-card-risk>
        </div>

        <!-- Activity -->
        <div class="g-card">
            <app-loan-card-activity [loanNumber]="loanNumber"></app-loan-card-activity>
        </div>

        <!-- Contacts -->
        <div class="g-card">
            <app-loan-card-contacts [loanNumber]="loanNumber"></app-loan-card-contacts>
        </div>
    </div>

    <p *ngIf="lastLOSUpdate" style="padding-left: 10px">
        <span class="g-text-title">Last LOS Update: &nbsp;</span>
        <span class="g-text-secondary">{{
            lastLOSUpdate | date : 'MM/dd/yyyy hh:mm aa' : 'UTC'
        }}</span>
    </p>
</mat-dialog-content>
